import {duration} from 'moment'
import {setupAxios} from '../app/modules/auth'
import {EmploymentTypeInput} from '../app/types/AdminModuleTypes'
import {api} from './APIMiddlewares'
import API from './APIUrl'
import {getNumber} from '../_metronic/helpers'

// form save api integration
export async function addEmploymentTypes(InputField: EmploymentTypeInput) {
  const {token, tenantId} = setupAxios()

  return await api
    .post(
      `/${API.EMPLOYMENTTYPE}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          name: InputField?.name,
          duration: getNumber(InputField?.duration),
          description: InputField?.description,
        }),
      },
      true
    )
    .then((res) => res)
}

//edit by id
export async function updateEmploymentTypesById(InputField: EmploymentTypeInput, id: string) {
  const {token, tenantId} = setupAxios()
  return await api
    .put(
      `/${API.EMPLOYMENTTYPE}/${id}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          name: InputField?.name,
          duration: getNumber(InputField?.duration),
          description: InputField?.description,
        }),
      },
      true
    )
    .then((res) => res)
}

//   get Holiday

export async function getEmploymentTypes() {
  const {token, tenantId} = setupAxios()
  return await api.get(`/${API.EMPLOYMENTTYPE}`, token, tenantId, false)
}

//   delete holiday

export async function deleteEmploymentTypes(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.delete(`/${API.EMPLOYMENTTYPE}/${id}`, token, tenantId, false)
}

//getHolidaybyid

export async function getEmploymentTypesById(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/${API.EMPLOYMENTTYPE}/${id}`, token, tenantId, false)
}
